import { t } from "../../../../../../utils/i18n";
import React, { useState } from "react";
import { CardType } from "../../Types";
import CardDetail from "./CardDetail";
import Modal from "./Modal";

interface Props {
  availableBalance: number;
  isQAUser: boolean;
  physicalCardTypes: CardType[];
  virtualCardTypes: CardType[];
  canApplyForVirtualCard: boolean;
  onSelectCardType: (e: any, cardType: string) => void;
  updateCouponCode: (couponCode: string) => void;
}

const CardTypes: React.FC<Props> = ({
  availableBalance,
  physicalCardTypes,
  virtualCardTypes,
  onSelectCardType,
  updateCouponCode,
  canApplyForVirtualCard,
}) => {
  const [modalContent, setModalContent] = useState<string | null>(null);

  const onClickCardType = (e: any, cardType: CardType) => {
    e.preventDefault();

    const isInsufficientBalance = (requiredFee) =>
      requiredFee > availableBalance;

    const isInsufficientBalanceWithCoupon = (requiredFee) => {
      if (requiredFee > availableBalance && availableBalance < 0) {
        return false;
      }

      return requiredFee > availableBalance;
    };

    if (
      cardType.is_coupon_claimable &&
      isInsufficientBalanceWithCoupon(Number(cardType.discounted_fee))
    ) {
      alert(t("cards.request_form.insufficient_balance"));
      return;
    }

    if (
      !cardType.is_coupon_claimable &&
      isInsufficientBalance(cardType.application_fee)
    ) {
      alert(t("cards.request_form.insufficient_balance"));
      return;
    }

    window.scrollTo(0, 0);
    onSelectCardType(e, cardType.type);
  };

  const handleTooltipClick = (tooltipText: string) => {
    setModalContent(tooltipText);
  };

  const closeModal = () => {
    setModalContent(null);
  };

  return (
    <>
      <div className="header">
        <h3 className="nav-steps d-none d-sm-flex pl-3">{t("cards.request_form.physical_cards")}</h3>
        <div className="nav-steps d-none d-sm-flex pl-3">
          <span>{t("cards.request_form.choose_your_card_type")}</span>
        </div>
      </div>
      <div className="cards-title-padding pr-3">
        <div className="cards-section">
          {physicalCardTypes.map((cardType, i) => (
            <div
              key={i}
              className="cards-container"
              style={{ backgroundColor: "#f5f4f9" }}
            >
              <CardDetail
                cardType={cardType}
                onClickCardType={onClickCardType}
                handleTooltipClick={handleTooltipClick}
                updateCouponCode={updateCouponCode}
              />
            </div>
          ))}
        </div>
        <hr />
        <h3 className="nav-steps d-none d-sm-flex">{t("cards.request_form.virtual_cards")}</h3>
        <div className="cards-section">
          {virtualCardTypes.map((cardType, i) => (
            <div
              key={i}
              className="cards-container"
              style={{ backgroundColor: "#f5f4f9" }}
            >
              <CardDetail
                disabled={!canApplyForVirtualCard}
                cardType={cardType}
                onClickCardType={onClickCardType}
                handleTooltipClick={handleTooltipClick}
                updateCouponCode={updateCouponCode}
              />
            </div>
          ))}

          <hr />
        </div>
      </div>

      <br />
      <br />
      {modalContent && (
        <Modal modalContent={modalContent} closeModal={closeModal} />
      )}
    </>
  );
};

export default CardTypes;
